import React from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "../../components/admin/AdminSidebar";

function AdminLayout() {
  return (
    <div
      className="d-flex"
      style={{ backgroundColor: "#f4f5fa", minHeight: "100vh" }}
    >
      <AdminSidebar />
      <div className="flex-grow-1 p-4" style={{ overflowY: "auto" }}>
        <Outlet />
      </div>
    </div>
  );
}

export default AdminLayout;
